// Test IDs for Manuel Santana site
export const NAV = {
  brand: "nav-brand-link",
  home: "nav-link-home",
  about: "nav-link-about",
  podcast: "nav-link-podcast",
  books: "nav-link-books",
  media: "nav-link-media",
  speaking: "nav-link-speaking",
  projects: "nav-link-projects",
  contact: "nav-link-contact",
  cta: "nav-cta-contact",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  primaryCta: "hero-cta-contact",
  secondaryCta: "hero-cta-podcast",
  scrollHint: "hero-scroll-indicator",
};

export const HOME = {
  latestEpisode: "home-latest-episode",
  aboutCta: "home-about-cta",
  booksCta: "home-books-cta",
  mediaCta: "home-media-cta",
  projectsCta: "home-projects-cta",
  contactCta: "home-contact-cta",
};

export const ABOUT = { section: "section-about", presskit: "about-press-kit-cta" };
export const PODCAST_T = {
  section: "section-podcast",
  spotify: "podcast-cta-spotify",
  apple: "podcast-cta-apple",
  youtube: "podcast-cta-youtube",
  trailerPlay: "podcast-trailer-play",
};
export const BOOKS_T = {
  section: "section-books",
  purchase: (i) => `book-${i}-purchase`,
};
export const MEDIA_T = { section: "section-media" };
export const SPEAKING_T = {
  section: "section-speaking",
  topics: "speaking-topics",
};
export const PROJECTS_T = {
  section: "section-projects",
  card: (slug) => `project-card-${slug}`,
};

export const CONTACT_T = {
  section: "section-contact",
  form: "contact-form",
  name: "contact-input-name",
  email: "contact-input-email",
  org: "contact-input-org",
  type: "contact-select-type",
  message: "contact-input-message",
  submit: "contact-submit-button",
  catMedia: "contact-cat-media",
  catPodcast: "contact-cat-podcast",
  catBusiness: "contact-cat-business",
  catGeneral: "contact-cat-general",
};

export const NEWSLETTER = {
  section: "section-newsletter",
  form: "newsletter-form",
  email: "newsletter-input-email",
  submit: "newsletter-submit-button",
};

export const FOOTER = {
  section: "site-footer",
  instagram: "footer-social-instagram",
  twitter: "footer-social-twitter",
  youtube: "footer-social-youtube",
  spotify: "footer-social-spotify",
  apple: "footer-social-apple",
};

export const PRESSKIT_T = {
  section: "section-presskit",
  downloadShort: "presskit-copy-short",
  downloadMedium: "presskit-copy-medium",
  downloadLong: "presskit-copy-long",
};

export const SEO_T = {
  page: "seo-topic-page",
};
